
import {  useSelector } from "react-redux";

import { getDownloadLicense, initiatePayment,getOrderTransaction,  initiateCFPayment} from "../feature-module/auth/services/privateapicalling";

function useCommonServices() {
 
  const token = useSelector((state) => state.auth.token);
  


  const downloadLicense = async (applicationId,role) => {
  
   
    const response = await getDownloadLicense(token , applicationId);
   
    return response

   
  };

  const doPayment = async (applicationId,paymentType,token,) => {
    //.log('app id at hook' , applicationId,paymentType)

     const body = {
        applicationId:applicationId,
        "payMode":paymentType
      }
      const res = await initiatePayment(body , token)
      //.log('resss', res.data)
      return res
  }

    const doPaymentForCf = async (applicationId,paymentType,Amount,token,) => {
    //.log('app id at hook' , applicationId,paymentType)

     const body = {
        applicationId:applicationId,
        "payMode":paymentType,
        Amount
      }
   
      const res = await initiateCFPayment(body , token)
   
      return res
      
  }

  const getOrderDetail = async (applicationId,orderID,token) => {


        const res = await getOrderTransaction(applicationId,orderID , token)
      //.log('resss', res.data)
      return res
  }


  return { token, downloadLicense , doPayment,getOrderDetail,doPaymentForCf };
}

export default useCommonServices;
